<template>
  <div class="xscontainer jsjiesh">

    <div class="njkeetret">
      <div class="erwerew">
        <el-page-header @back="goBack" :content="currobj.biaoti">
        </el-page-header>
      </div>
<!--      <div class="btme">{{ currobj.biaoti }}</div>-->
      <video ref="videoPlayer" class="shipincss" controls controlslist="nodownload">
        <source :src="getVideoUrl(currobj.neirong)" type="video/mp4">
      </video>
      <div class="hhhksee">
        <!--          <p>我的链接：{{ link }}</p>-->
        <el-button type="info" round @click="copyLink(currobj.neirong)">复制链接分享给更多人</el-button>
        <p v-if="copied" class="success">链接已复制！</p>
      </div>
    </div>
    <div class="dsfsdfg" v-model="fwcishu">【访问次数:{{fwcishu}}】</div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      shipins: [],
      currobj: {},
      copied: false,
      fwcishu:0
    };
  },
  mounted() {
    this.currobj = this.$route.query.currobj;
    this.getVideoUrl();
    this.queryshipin();
  },
  created() {
    this.currobj = this.$route.query.currobj;
    this.tongji( this.currobj.biaoti);
  },
  methods: {
    tongji(caidan) {
      var that = this;
      this.$ajax
          .post(this.GLOBAL.sys_addr + '/tongji/tTongji/tj', {caidan: caidan})
          .then(function (response) {
            if (response.status == 200) {
              that.fwcishu = response.data;
            }
          });
    },
    copyLink(lianjie) {
      const el = document.createElement('textarea')
      el.value = this.getVideoUrl(lianjie)
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)

      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 2000)
    },
    goBack(){
      this.$router.back();
    },
    getVideoUrl() {
      return this.GLOBAL.sys_addr + '/shipin/tShipin/video?spm=' + this.currobj.neirong;
    },
    queryshipin() {
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/shipin/tShipin/list?_t=' + new Date().getTime() + '&column=id&fenlei=' + this.currobj.fenlei + '&order=asc&pageNo=' + 0 + '&pageSize=' + 3)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.shipins = response.data.result.records;
            } else {
              that.$notify.warning({position: 'bottom-right', title: '提示', message: response.data.msg});
            }
          });
    }
  }
};
</script>

<style scoped>
.njkeetret {
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5rem;
}

.btme {
  width: 100%;
  font-size: 1.1rem;
  font-weight: bold;
  text-align: left;
  margin-bottom: -3rem;
}

.ggcs334 {
  width: 60%;
  background-image: url('../../assets/xxkc/33@4x.png');
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.shipincss {
  width: 100%;
  height: 100%;
}

.playcs32 {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  box-shadow: 0px 0px 1px 0px #55a2da;
}

.gg24 {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.ksdfksd {
  width: 20%;
  display: flex;
  flex-direction: column;
  align-items: start;
}

.evei13 {
  width: 100%;
  height: 10rem;
  background-color: #3c77eb;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: bold;
}

.jesd {
  width: 100%;
  text-align: center;
  margin-top: 0.6rem;
  font-size: 0.8rem;
}

.gg3 {
  width: 100%;
  display: flex;
  flex: 3;
  justify-content: space-between;
}

.mmlist {
  width: 30%;
}

.ljsdke {
  width: 100%;
  font-size: 0.8rem;

  overflow: hidden;
  text-overflow: ellipsis;
}

.kksc {
  font-size: 1.1rem;
  font-weight: bold;
  color: #ffffff;
}
.erwerew{
  width: 100%;
  display: flex;
  justify-content: start;
}
</style>
